import { ACTIONS } from '../../constants';

const dataDays = (state = {}, action) => {
  switch (action.type) {
    // todo - maybe implement ACTIONS.DAY_FETCH to show some day-loader
    case ACTIONS.DAY_FETCH_DONE:
      // todo - check if nesting data is ok - or send as params directly
      return {
        ...state,
        [`${action.data.idMonth}-${action.data.idDay}`]: {
          data: action.data.data,
          tip: action.data.tip
        }
      };
    default:
      return state;
  }
};

export default dataDays;



// WEBPACK FOOTER //
// ./src/redux/reducers/dataDays.js